import { useState, useEffect } from 'react';
import './Testimonials.css';

const Testimonials = () => {
  const testimonials = [
    {
      text: "Nozomi Robotics has transformed how we teach computational thinking in our classroom. The students are engaged and actually understand the concepts because they can see them in action.",
      author: "Sarah J.",
      role: "Middle School Teacher",
      image: "/placeholder-teacher.jpg"
    },
    {
      text: "My 12-year-old daughter went from having no interest in programming to building her own robot challenges. The visual interface makes it so accessible, and she loves seeing her code make something move in the real world.",
      author: "Michael T.",
      role: "Parent",
      image: "/placeholder-parent.jpg"
    },
    {
      text: "As someone researching educational technology, I'm impressed by how well Nozomi Robotics integrates computational thinking principles into an engaging hands-on experience. The research foundations are evident in the design.",
      author: "Dr. Lisa M.",
      role: "Education Researcher",
      image: "/placeholder-researcher.jpg"
    }
  ];

  // eslint-disable-next-line
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  // const handleDotClick = (index) => {
  //   setCurrentIndex(index);
  // };

  // return (
  //   <section id="testimonials" className="section testimonials-section">
  //     <div className="container">
  //       <div className="section-title">
  //         <h2>What People Are Saying</h2>
  //         <p>Feedback from educators, parents, and researchers</p>
  //       </div>

  //       <div className="testimonials-slider">
  //         <div className="testimonial-card">
  //           <p className="testimonial-text">"{testimonials[currentIndex].text}"</p>

  //           <div className="testimonial-author">
  //             <div className="author-image">
  //               <img src={testimonials[currentIndex].image} alt={testimonials[currentIndex].author} />
  //             </div>
  //             <div className="author-info">
  //               <h4>{testimonials[currentIndex].author}</h4>
  //               <p>{testimonials[currentIndex].role}</p>
  //             </div>
  //           </div>
  //         </div>

  //         <div className="testimonial-dots">
  //           {testimonials.map((_, index) => (
  //             <button
  //               key={index}
  //               className={`testimonial-dot ${index === currentIndex ? 'active' : ''}`}
  //               onClick={() => handleDotClick(index)}
  //               aria-label={`Testimonial ${index + 1}`}
  //             />
  //           ))}
  //         </div>
  //       </div>
  //     </div>
  //   </section>
  // );
};

export default Testimonials;